import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../../Config/Config";

export const fetchTestNameData = createAsyncThunk("api/testname", async () => {
  const response = await fetch(
    `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-approved-tests`
  );
  const data = await response.json();
  return data;
});

const testnameSlice = createSlice({
  name: "testname",
  initialState: {
    testnamedata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestNameData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestNameData.fulfilled, (state, action) => {
        state.loading = false;
        state.testnamedata = action.payload;
      })
      .addCase(fetchTestNameData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default testnameSlice.reducer;
